module.exports = __webpack_public_path__ + "img/cplusplus.f278be79.png";